import { defineStore } from 'pinia';
import { Api } from '@/Api';
import { useViewerItemStore } from '@/modules/viewer/store/useViewerItemStore';

export interface Integration {
  name: string;
  description: string;
  enabled: boolean;
  icon: string;
  color: string;
}
export interface IntegrationState {
  integrations: Integration[];
  projectId: string | null;
  token: string | null;
  loading: boolean;
  error: string | null;
}

export const useIntegrationStore = defineStore('integrationStore', {
  state: () =>
    ({
      integrations: [],
      projectId: null,
      token: null,
      loading: false,
      error: null,
    }) as IntegrationState,
  actions: {
    async fetchIntegrations(forceRefresh: boolean = false) {
      this.$patch({
        loading: true,
        error: null,
      });
      try {
        const response = await Api.integrations.list(forceRefresh);
        const integrations = response.data?.integrations?.attributes || [];
        const projectId = response.data?.projectId?.attributes;
        const token = response.data?.token?.attributes;
        this.$patch({
          integrations: integrations,
          projectId: projectId,
          token: token,
        });
      } catch (err: any) {
        this.$patch({
          error: err.message || 'Failed to fetch integrations',
        });
      } finally {
        this.$patch({
          loading: false,
        });
      }
    },
    async sendTo(integration: string) {
      const itemStore = useViewerItemStore();
      if (!itemStore.id) {
        return;
      }
      await Api.integrations.send(integration, itemStore.id);
    },
    setIntegrationToken(token: string) {
      this.token = token;
    },
  },
  getters: {
    integration_token: state => state.token,
    integration_project_id: state => state.projectId,
  },
});
